import { Settings04Icon } from '@/components/icons/Settings04Icon';

import {
  TileNodeControlButton,
  TileNodeControlButtonProps,
} from './TileNodeControlButton';

export const TileSettingsControlButton = (
  props: TileNodeControlButtonProps
) => {
  return (
    <TileNodeControlButton
      data-testid="edit-tile-control-button"
      square={false}
      startIcon={Settings04Icon}
      {...props}
    >
      Tile settings
    </TileNodeControlButton>
  );
};
